import { DropdownSelect } from "../../ui/dropdown-select";

interface FilterSelectProps {
  label: string;
  value: string;
  options: { name: string; value: string }[];
  onChange: (value: string) => void;
  placeholder?: string;
}

export function FilterSelect({
  label,
  value,
  options,
  onChange,
  placeholder = "Select an option",
}: FilterSelectProps) {
  const dropdownOptions = options.map((opt) => ({
    value: opt.value,
    label: opt.name,
  }));

  return (
    <div className="tw:grid tw:gap-2">
      <label className="tw:text-sm tw:font-medium tw:leading-none tw:peer-disabled:cursor-not-allowed tw:peer-disabled:opacity-70">
        {label}
      </label>
      <DropdownSelect
        value={value}
        onValueChange={onChange}
        options={dropdownOptions}
        placeholder={placeholder}
        triggerClassName="tw:w-[180px]"
      />
    </div>
  );
}
